module.exports = __webpack_public_path__ + "static/Metropolis-Regular-2f2327628b89e86a924f5e69d4c6884d.woff";